export default __webpack_public_path__ + "static/media/hudie.81244c4b.png";